require('./bootstrap');
require('./sidemenu');
require('./dropdown');
require('./users');


const feather = require('feather-icons')
feather.replace();
window.Swal = require('sweetalert2')
window.toastr = require('toastr')
toastr.options = {
    "closeButton": true,
    "debug": false,
    "newestOnTop": false,
    "progressBar": true,
    "positionClass": "toast-bottom-left",
    "preventDuplicates": false,
    "onclick": null,
    "showDuration": "300",
    "hideDuration": "1000",
    "timeOut": "5000",
    "extendedTimeOut": "1000",
    "showEasing": "swing",
    "hideEasing": "linear",
    "showMethod": "fadeIn",
    "hideMethod": "fadeOut"
}

$('#log-out').click(function(e){
    Swal.fire({
        title: 'آیا مطمئنید که می خواهید از برنامه خارج شوید؟',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'بله!',
        cancelButtonText: 'لغو'
    }).then((result) => {
        if (result.value) {
            $('#form-logout').submit();
        }
    });
})

$('html').removeClass('dark');
